// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__s8zcN","imageContainer":"avatar_imageContainer__fVPVo","selected":"avatar_selected__5sR7g","selectedIndicator":"avatar_selectedIndicator__N8q2I"};